import { defineMessages } from "react-intl";

export const scope = "components.DepositFeeWarning";

export const messages = defineMessages({
  comissionMessage: {
    id: `${scope}.comissionMessage`,
    defaultMessage: "Comision: {fee}",
  },
  bothMessage: {
    id: `${scope}.bothMessage`,
    defaultMessage:
      "Las transferencias entrantes por {pn} tienen una comisión del {fee_per}% del monto total depositado más {fee_value} {currency} del resultante.",
  },
});
